import React from "react";
import AmCharts from "@amcharts/amcharts3-react";
import { Typography } from "material-ui";
import { chartDrawn } from "./../../../utilities/charts";
import moment from "moment";

const days = {
  Monday: "Lunes",
  Tuesday: "Martes",
  Wednesday: "Miercoler",
  Thursday: "Jueves",
  Friday: "Viernes",
  Saturday: "Sábado",
  Sunday: "Domingo"
};

const ComparativeChartsTile = props => {
  const { lang, data } = props;

  return (
    <div className="dashboard-tile">
      <div className="tile-header">{lang.RalentiPorFlota}</div>
      <div className="tile-chart-body">
        <ComparativeDeadTimeChart lang={lang} data={data.ComparativaRalenti} />
      </div>

      <div style={{ fontSize: "small", width: "50%", margin: "auto" }}>
        <div
          style={{
            width: "10px",
            height: "10px",
            borderRadius: "100%",
            backgroundColor: "#64B5F6",
            display: "inline-block"
          }}
        />
        <span>{lang.SemanaPasada} </span>
        <div
          style={{
            width: "10px",
            height: "10px",
            borderRadius: "100%",
            backgroundColor: "#FFC400",
            display: "inline-block",
            marginLeft: "0.5rem"
          }}
        />
        <span>{lang.SemanaEnCurso}</span>
      </div>
      {/* <div style={{ backgroundColor: "blue" }} className="tile-footer">
        <div className="slide-bullet" />
        <div className="slide-bullet" />
        <div className="slide-bullet" />
        <div className="slide-bullet" />
      </div> */}
    </div>
  );
};

const ComparativeDeadTimeChart = props => {
  const { lang, data } = props;

  let mapedData = data.map(d => ({
    ...d,
    Dia: lang[d.Dia],
    Fecha1: moment(d.Fecha1).format(" DD-MMM-YYYY"),
    Fecha2: moment(d.Fecha2).format(" DD-MMM-YYYY")
  }));

  const config = {
    type: "serial",
    theme: "light",
    marginRight: 80,
    dataProvider: [...mapedData],

    listeners: [
      {
        event: "drawn",
        method: chartDrawn
      }
    ],
    balloon: {
      cornerRadius: 6,
      horizontalPadding: 15,
      verticalPadding: 10
    },
    valueAxes: [
      {
        axisAlpha: 0,
        position: "left",
        title: lang.Minutos
      }
    ],
    graphs: [
      {
        bullet: "circle",
        bulletBorderAlpha: 1,
        bulletBorderThickness: 1,
        balloonText: "[[value]] Min. |  [[description]]",
        fillAlphas: 0.3,
        fillColorsField: "lineColor",
        lineColorField: "lineColor",
        title: "Tiempo",
        valueField: "Tiempo1",
        descriptionField: "Fecha1"
      },
      {
        bullet: "circle",
        bulletBorderAlpha: 1,
        bulletBorderThickness: 1,
        balloonText: "[[value]] | [[description]]",
        fillAlphas: 0.3,
        fillColorsField: "lineColor",
        lineColorField: "lineColor",
        title: "Tiempo",
        valueField: "Tiempo2",
        descriptionField: "Fecha2"
      }
    ],
    chartCursor: {
      cursorAlpha: 0,
      fullWidth: true
    },

    categoryField: "Dia",
    categoryAxis: {
      autoGridCount: false,
      axisColor: "#555555",
      gridAlpha: 0,
      gridCount: 50
    },

    export: {
      enabled: true
    }
  };

  return (
    <AmCharts.React
      style={{
        width: "100%",
        height: "10rem",
        fontSize: "10px",
        overflow: "hidden"
      }}
      options={config}
    />
  );
};

export default ComparativeChartsTile;



// WEBPACK FOOTER //
// ./src/containers/Dashboard/DashboardTiles/ComparativeChartsTile.js